import { render, staticRenderFns } from "./QuickAccessMenu.vue?vue&type=template&id=6d7ee0d2&scoped=true&"
import script from "./QuickAccessMenu.vue?vue&type=script&lang=js&"
export * from "./QuickAccessMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuickAccessMenu.vue?vue&type=style&index=0&id=6d7ee0d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7ee0d2",
  null
  
)

export default component.exports